import { render, staticRenderFns } from "./import-case-detail.vue?vue&type=template&id=3ff148aa&scoped=true"
import script from "./import-case-detail.vue?vue&type=script&lang=ts"
export * from "./import-case-detail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff148aa",
  null
  
)

export default component.exports